const breakpoints = {
  sm: 640,
  md: 865,
  lg: 975, //Set to match Gin toolbar
  smxl: 1050,
  mdxl: 1351,
  xl: 1500,
  "2xl": 1800,
  header: 1050,
};

const breakpointsWithPx = {};
Object.keys(breakpoints).map((key) => {
  breakpointsWithPx[key] = `${breakpoints[key]}px`;
});

export const Breakpoints = breakpoints;

export const BreakpointsWithPx = breakpointsWithPx;
